
import React from 'react';

const areas = [
  { name: 'Kondapur', distance: 'Clinic Location', highlight: true },
  { name: 'Hitech City', distance: '3 km away' },
  { name: 'Gachibowli', distance: '4 km away' },
  { name: 'Kothaguda', distance: '2 km away' },
  { name: 'Masjid Banda', distance: '1.5 km away' },
  { name: 'Hafeezpet', distance: '3.5 km away' },
  { name: 'Madhapur', distance: '4 km away' },
  { name: 'Kukatpally', distance: '5 km away' },
  { name: 'Miyapur', distance: '7 km away' },
  { name: 'JNTU', distance: '6 km away' },
  { name: 'Nallagandla', distance: '5 km away' },
  { name: 'Chandanagar', distance: '6 km away' },
];

export function ServiceAreas() {
  return (
    <section
      id="service-areas"
      aria-labelledby="areas-heading"
      className="py-20 bg-gradient-to-br from-teal-50 via-white to-cyan-50"
    >
      <div className="max-w-7xl mx-auto px-6">
        <header className="text-center mb-12">
          <div className="inline-block bg-teal-50 px-4 py-2 rounded-full mb-4">
            <span className="text-sm font-semibold text-teal-600">
              Areas We Serve
            </span>
          </div>
          <h2
            id="areas-heading"
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-3"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Dental Care Near You in Hyderabad
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            <strong>Sri Maruthi Teeth Empire</strong> on Botanical Garden Road, Kondapur
            serves patients across western Hyderabad. Whether you&apos;re in{' '}
            <strong>Hitech City</strong>, <strong>Gachibowli</strong>, or{' '}
            <strong>Madhapur</strong>, quality dental care is just minutes away.
          </p>
        </header>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {areas.map((area, index) => (
            <a
              key={index}
              href="#booking"
              aria-label={`Book dental appointment from ${area.name} - ${area.distance}`}
              className={`group rounded-xl p-4 text-center transition-all duration-300 cursor-pointer ${
                area.highlight
                  ? 'bg-teal-600 text-white shadow-lg shadow-teal-200'
                  : 'bg-white border border-gray-100 hover:border-teal-300 hover:shadow-md'
              }`}
            >
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full mx-auto mb-2 ${
                  area.highlight ? 'bg-white/20' : 'bg-teal-50 group-hover:bg-teal-100'
                }`}
                aria-hidden="true"
              >
                <i
                  className={`ri-map-pin-2-line text-lg ${
                    area.highlight ? 'text-white' : 'text-teal-600'
                  }`}
                ></i>
              </div>
              <h3
                className={`text-sm font-bold mb-1 ${
                  area.highlight ? 'text-white' : 'text-gray-900'
                }`}
              >
                {area.name}
              </h3>
              <p
                className={`text-xs ${
                  area.highlight ? 'text-teal-100' : 'text-gray-500'
                }`}
              >
                {area.distance}
              </p>
            </a>
          ))}
        </div>

        <div className="mt-10 bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-50 rounded-2xl flex-shrink-0" aria-hidden="true">
              <i className="ri-road-map-line text-2xl text-teal-600"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-bold text-gray-900 mb-1">
                <a href="#booking">
                  Easy to Reach from Anywhere in West Hyderabad
                </a>
              </h3>
              <p className="text-gray-600 text-sm">
                Located on <strong>Botanical Garden Road</strong>, Sri Maruthi Teeth Empire
                is well-connected via Kondapur main road. Free parking
                available. Nearest landmarks: KV Rangareddy Botanical Garden,
                Kondapur Bus Stop, and Hitech City Metro Station.
              </p>
            </div>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Sri+Maruthi+Teeth+Empire+Dental+Clinic+Kondapur+Hyderabad"
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Get directions to Sri Maruthi Teeth Empire Dental Clinic on Google Maps"
              className="inline-flex items-center gap-2 bg-teal-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
            >
              <i className="ri-direction-line text-lg" aria-hidden="true"></i>
              Get Directions
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
